import { InputBaseComponentProps, TextField } from "@mui/material";
import { ChangeEventHandler } from "react";

export interface IKeydriveTextfield {
    onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined;
    placeholder?: string | undefined;
    value: unknown;
    label?: string | undefined;
    needFullWidth?: boolean;
    hintTextError?: string;
    required?: boolean;
    type?: string;
    disabled?: boolean;
    inputProps?: InputBaseComponentProps | undefined
}

export const KeydriveTextfield: React.FC<IKeydriveTextfield> = ({
    onChange,
    placeholder,
    value,
    label,
    needFullWidth,
    hintTextError,
    required,
    type,
    disabled,
    inputProps
}) => {
    return (
        <TextField 
            required={required}
            error={hintTextError != undefined}
            variant="standard"
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            label={label}
            fullWidth={needFullWidth}
            helperText={hintTextError}
            type={type}
            disabled={disabled}
            inputProps={inputProps}
        />
    )
}